/*============================================================================
Strap Finder - Migrated over from Delugs Flex theme
==============================================================================*/
let format = window.theme.settings.money_with_currency_format || "${{amount}}";
// console.log(format,'format');
if ($('.strap-finder').length) {
  const self = this;
  this.$container = $(self.container);
  const strapfinder = document.createEvent('Event');
  strapfinder.initEvent('build', true, true);
  document.addEventListener('build', (event) => {
  }, false);

  //load all straps
  var strap_container = $('.strap-finder__strap-swatch-container');
  if ($(window).width() < 769){
    strap_container = $('.strap-finder__strap-swatch-container-mobile');
  }

  var product_count = parseInt(strap_container.attr('data-collection-size'));
  var StrapItemTemplate = $('[data-strap-item-template]').html();
  const collectionCallLimit = 50;
  const loopCount = Math.ceil(product_count / collectionCallLimit);
  var page_handle = $('.strap-finder').attr('handle');
  let items_container = [];
  var alltags = [];
  var collectionPageXhrs = [];
  for (var i = 0;i < loopCount; i++) {
    pageno = i + 1;
    if (i == 0) {
      getAllProducts(pageno,page_handle, false, items_container);
    } else {
      getAllProducts(pageno,page_handle, true, items_container);
    }
  }

  function getAllProducts(page,page_handle, initiated, items_container) {
    var collectionPageXhr = $.ajax({
      url: '/collections/' + page_handle + '?view=ajax&limit=50&page=' + page,
      cache: false,
      success: function(response) {  
        let filterProducts = JSON.parse(response);
        filterProducts = filterProducts.products;
        let items = '';
        for (let i = 0; i < filterProducts.length; i++) {
          var selected = '';
          if (filterProducts[i].handle != page_handle && !filterProducts[i].handle.includes('strap-finder')) {
            var bottom_strap = '';
            var top_strap = '';
            //getting top and bottom strap
            // console.log(filterProducts[i].media)
            if (filterProducts[i].media == undefined) {
              // console.log(filterProducts[i])
            }
            if (filterProducts[i].media != undefined) {
              for (let v = 0; v < filterProducts[i].media.length; v++) {
                if (filterProducts[i].media[v].alt == "strap-finder_bottom") {
                  bottom_strap = filterProducts[i].media[v].src;
                  // console.log(filterProducts[i].handle + ' : ' + bottom_strap);
                }
                if (filterProducts[i].media[v].alt == "strap-finder_top") {
                  top_strap = filterProducts[i].media[v].src;
                }
              }
            }
            
            //initiating selected
            if (initiated == false) {
              // console.log("initiated")
              initiated = true;
              selected = "selected";
              // init top and bottom strap image
              $('.image-container.top-strap').append('<img class="transition--fade-in zoom-img lazyautosizes lazyload" src=' + top_strap + '/>')
              $('.image-container.bottom-strap').append('<img class="transition--fade-in zoom-img lazyautosizes lazyload" src=' + bottom_strap + '/>')
              // init main selector
              for (let v = 0; v < filterProducts[i].variants.length; v++) {
                var option1 = filterProducts[i].variants[v].option1;
                var option = $('<option value=' + filterProducts[i].variants[v].id +' availability=' + filterProducts[i].variants[v].available + ' price=' + filterProducts[i].variants[v].price + '>'+ filterProducts[i].variants[v].title + '</option>');
               
                for (let o = 1; o <= filterProducts[i].options.length; o++) {
                 if (o == 1) {
                  option.attr('option1', filterProducts[i].variants[v].option1)
                 }
                 if (o == 2) {
                  option.attr('option2', filterProducts[i].variants[v].option2)
                 }
                 if (o == 3) {
                  option.attr('option3', filterProducts[i].variants[v].option3)
                 }
                }
                $('[data-variant-selector]').val(filterProducts[i].variants[0].id)
                $('[data-variant-selector]').append(option);
              }
              // init first strap selected selectors
              for (let o = 1; o <= filterProducts[i].options.length; o++) {
                var select = $('<select class="single-option-selector"></select>');
                if (o == 1) {
                  var checker_array = [];
                  for (let v = 0; v < filterProducts[i].variants.length; v++) {
                    var checker = true;
                    var option1 = filterProducts[i].variants[v].option1;
                    for (let c = 0; c < checker_array.length; c++) {
                      if (checker_array[c] == filterProducts[i].variants[v].option1) {
                        checker = false;
                      }
                    }
                    if (checker == true ){
                      checker_array.push(filterProducts[i].variants[v].option1)
                      if (v == 0) {
                        select.append('<option value="' + filterProducts[i].variants[v].option1 + '" selected="selected">'+ option1 + '</option>');
                      } else {
                        select.append('<option value="' + filterProducts[i].variants[v].option1 + '">'+ option1 + '</option>');
                      }
                    }
                  }   
                }

                if (o == 2) {
                  var checker_array = [];
                  for (let v = 0; v < filterProducts[i].variants.length; v++) {
                    var checker = true;
                    var option2 = filterProducts[i].variants[v].option2;
                    for (let c = 0; c < checker_array.length; c++) {
                      if (checker_array[c] == filterProducts[i].variants[v].option2) {
                        checker = false;
                      }
                    }
                    if (checker == true ){
                      checker_array.push(filterProducts[i].variants[v].option2)
                      if (v == 0) {
                        select.append('<option value="' + filterProducts[i].variants[v].option2 + '" selected="selected">'+ option2 + '</option>');
                      } else {
                        select.append('<option value="' + filterProducts[i].variants[v].option2 + '">'+ option2 + '</option>');
                      }
                    }
                  }
                }

                if (o == 3) {
                  var checker_array = [];
                  for (let v = 0; v < filterProducts[i].variants.length; v++) {
                    var checker = true;
                    var option3 = filterProducts[i].variants[v].option3;
                    for (let c = 0; c < checker_array.length; c++) {
                      if (checker_array[c] == filterProducts[i].variants[v].option3) {
                        checker = false;
                      }
                    }
                    if (checker == true ){
                      checker_array.push(filterProducts[i].variants[v].option3)
                      if (v == 0) {
                        select.append('<option value="' + filterProducts[i].variants[v].option3 + '" selected="selected">'+ option1 + '</option>');
                      } else {
                        select.append('<option value="' + filterProducts[i].variants[v].option3 + '">'+ option1 + '</option>');
                      }
                    }
                  }
                }
                p = o - 1;
                var label = $('<div class="strap-finder__watch-title">' + filterProducts[i].options[p] + '</div>');
                select.attr('option',o);
                var select_container = $('<div class="strap-finder__select-container"></div>')
                select_container.append(label);
                select_container.append(select);
                $('.strap-finder-selector__container').append(select_container);
              }

              $('.strap-finder__strap-title').text(filterProducts[i].title);
              let url = '/products/' + filterProducts[i].handle;
              $('.strap-finder__strap-title').attr('href', url)
              $('.strap-finder__strap-title').attr('handle', filterProducts[i].handle)
              $('.current_price').html(formatMoney(filterProducts[i].price, format));
              $('.strap-finder__strap-mobile').attr('src', filterProducts[i].featured_image.replace(/(\.[^.]*)$/, '_100x@2x$1'));
              var desc = filterProducts[i].content;
              $('.strap-finder__strap-description').empty();
              $('.strap-finder__strap-description').append(desc);
              // init desc 
              var desc = $('.strap-finder__face-swatch.index--0').attr('desc');
              if (desc.includes(',')) {
                desc = desc.split(',');
                var lugwidth = desc[1].split(':');
                lugwidth = lugwidth[1].replace('mm','').trim();
                let selector = $('.strap-finder-selector__container').find('[option="'+ 1 + '"] option').each(function(){
                  var optlug = $(this).attr('value').split('-');
                  optlug = optlug[0].trim();
                  if (lugwidth == optlug) {
                    $(this).siblings().removeAttr('selected');
                    $(this).attr('selected', 'selected');
                    $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').val($(this).attr('value'));
                    $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').change();
            
                  }
                });
              }
              var margin_top = $('.strap-finder__face-swatch.index--0').attr('margin-top');
              var margin_bottom = $('.strap-finder__face-swatch.index--0').attr('margin-bottom');
              if (margin_top != null && margin_top != undefined && margin_top != '') {
                margin_top = margin_top.split('=');
                margin_top = margin_top[1].trim() + '%';
                margin_top = margin_top.toString();
                $('.image-container.watch').attr('margin-top', margin_top)
                $('.image-container.watch').css("margin-top", `${margin_top}`);
              }
              if (margin_bottom != null && margin_bottom != undefined && margin_bottom != '') {
                margin_bottom = margin_bottom.split('=');
                margin_bottom = margin_bottom[1].trim() + '%';
                margin_bottom = margin_bottom.toString();
                $('.image-container.watch').attr('margin-bottom', margin_bottom)
                $('.image-container.watch').css("margin-bottom", margin_bottom);
              }
            }
            var variant_id = [];
            var options = filterProducts[i].options;

            for (let v = 0; v < filterProducts[i].variants.length; v++) {
              var var_options;
              if (filterProducts[i].options.length == 1) {
                var_options = filterProducts[i].variants[v].option1;
              } else if (filterProducts[i].options.length == 2) {
                var option1 = filterProducts[i].variants[v].option1;
                var option2 = filterProducts[i].variants[v].option2;
                var_options = option1 + '%' + option2;
              } else if (filterProducts[i].options.length == 3) {
                var option1 = filterProducts[i].variants[v].option1;
                var option2 = filterProducts[i].variants[v].option2;
                var option3 = filterProducts[i].variants[v].option3;
                var_options = option1 + '%' + option2 + ',%' + option3;
              }
             
              var variant_content = filterProducts[i].variants[v].id + '/' + filterProducts[i].variants[v].available + '/' + filterProducts[i].variants[v].price + '/' + var_options ;
              variant_id.push(variant_content)
            }
            var tags = "";
            var filtertags = "";
            for (let v = 0; v < filterProducts[i].tags.length; v++) {
              if (filterProducts[i].tags[v].includes('strap-finder')) {
                tags = tags + "/" + filterProducts[i].tags[v];
              } else {
                filtertags = filtertags + "%" + filterProducts[i].tags[v];
              }

              //getting all tags 
              var exist = false;
              for (let t = 0; t < alltags.length; t++) {
                if (alltags[t].toLowerCase() == filterProducts[i].tags[v].toLowerCase()) {
                  exist = true;
                }
              }
              if (exist == false) {
                alltags.push(filterProducts[i].tags[v].toLowerCase());
              }
            }
            let item = StrapItemTemplate
              .replace(/{title}/g, filterProducts[i].title)
              .replace(/{strap_featured_image}/g, filterProducts[i].featured_image != null && filterProducts[i].featured_image.replace(/(\.[^.]*)$/, '_100x@2x$1'))
              .replace(/{variants}/g, variant_id)
              .replace(/{selected}/g, selected)
              .replace(/{top-strap}/g, top_strap)
              .replace(/{bottom-strap}/g, bottom_strap)
              .replace(/{options}/g, options)
              .replace(/{tags}/g, tags)
              .replace(/{filtertags}/g, filtertags)
              .replace(/{handle}/g, filterProducts[i].handle)
            items += item;
          }
        }
        items_container[page - 1] = items;
      },
      error: function(error) {
          // console.log(error);
      }
    });
    collectionPageXhrs.push(collectionPageXhr);
  }
  $.when.apply($, collectionPageXhrs).done(function() {
    $('.strap-finder').removeClass('isLoading'); 
    $('.strap-finder__loader').addClass('hide');  
    for (let i = 0; i < items_container.length; i++) {
      strap_container.append(items_container[i])
    }
    //include and exclude functionality
    // var selector = $('.carousel-cell.face.index--0').attr('value') 
    var selector = $('.strap-finder__face-swatch.index--0').attr('value') 
    if (selector.includes('include_only')) {
      var selector_tags = selector.split('=');
      selector_tags[1] = selector_tags[1].split(',')
      strap_container.find('.strap-finder__strap-swatch').each(function(){
        var show = false;
        $(this).addClass('hide-strap');
        let tags = $(this).attr('tag')
        if (tags != undefined) {
          tags = tags.split('/');
          for (let c = 0; c < selector_tags[1].length; c++) {
            for (let p = 0; p < tags.length; p++) {
              if (selector_tags[1][c] == tags[p]){
                // console.log(selector_tags[1][c] + " : " + tags[p])
                show = true;
              }
            }
          }
        }
        
        if (show) {
          $(this).removeClass('hide-strap');
        }
      });
    } else if (selector.includes('exclude')) {
      var selector_tags = selector.split('=');
      selector_tags[1] = selector_tags[1].split(',');
      strap_container.find('.strap-finder__strap-swatch').each(function(){
        var hide = false;
        $(this).removeClass('hide-strap');
        let tags = $(this).attr('tag')
        if (tags != undefined) {
          tags = tags.split('/');
          for (let c = 0; c < selector_tags[1].length; c++) {
            for (let p = 0; p < tags.length; p++) {
              if (selector_tags[1][c] == tags[p]){
                hide = true;
              }
            }
          }
        }
        if (hide) {
          $(this).addClass('hide-strap');
        }
      });
    } else {
      strap_container.find('.strap-finder__strap-swatch').each(function(){
        $(this).removeClass('hide-strap');
      });
    }

    //reducing filter to available
    setTimeout(function(){
      $('.strap-finder').removeClass('isLoading'); 
      $('.strap-finder__loader').addClass('hide');                
    }, 1000);

    $('.strap-finder__filter.swatch').each(function(){
      var show_category = false;
      var tags = $(this).attr('tags');
      tags = tags.split(',')
      for (let t = 0; t < tags.length; t++) {
        tags[t] = tags[t].trim();
        tags[t] = tags[t].toLowerCase();
      }
      var filtered_tags = tags.filter(f => alltags.includes(f));
      $(this).find('.strap-finder__filter-tags').each(function(){
        var target =  $(this).attr('target');
        target = target.trim();
        target = target.toLowerCase();
        var show = false;
        for (let t = 0; t < filtered_tags.length; t++) {
          if (target == filtered_tags[t]) {
            show = true;
          }
        }
        if (!show) {
          $(this).addClass('no-product');
        }  else {
          show_category = true;
        }
      });
      if (show_category) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    var face_all_tags = [];
    $('.strap-finder__face-swatch').each(function(){
      if (!$(this).hasClass('face-swatch-button') && !$(this).hasClass('strap-finder__watch-filter-tags')) {
        var show_category = false;
        var tags = $(this).attr('tag');
        tags = tags.split(',')
        for (let p = 0; p < tags.length; p++) {
          var exist = false;
          tags[p] = tags[p].trim();
          tags[p] = tags[p].toLowerCase();
          for (let t = 0; t < face_all_tags.length; t++) {
            if (face_all_tags[t] == tags[p]) {
              exist = true;
            }
          }
          if (!exist) {
            face_all_tags.push(tags[p]);
          }
        }
      }
    });
    
    $('.strap-finder__filter.face').each(function(){
      console.log('dee');
      var show_category = false;
      var tags = $(this).attr('tags');
      tags = tags.split(',')
      for (let t = 0; t < tags.length; t++) {
        tags[t] = tags[t].trim();
        tags[t] = tags[t].toLowerCase();
      }
      var filtered_tags = tags.filter(f => face_all_tags.includes(f));
      $(this).find('.strap-finder__watch-filter-tags').each(function(){
        var target =  $(this).attr('target');
        target = target.trim();
        target = target.toLowerCase();
        var show = false;
        for (let t = 0; t < filtered_tags.length; t++) {
          filtered_tags[t] = filtered_tags[t].trim();
          filtered_tags[t] = filtered_tags[t].toLowerCase();
          if (target == filtered_tags[t]) {
            show = true;
          }
        }
        if (!show) {
          $(this).addClass('no-product');
          $(this).addClass('hide')
        } else {
          $(this).removeClass('no-product');
          show_category = true;
        }
      });
      if (show_category) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    $('.strap-finder__swatch-container.face').each(function(){
      var show_category = false;
      var tags = $(this).attr('tags');
      tags = tags.split(',')
      for (let t = 0; t < tags.length; t++) {
        tags[t] = tags[t].split('=');
        tags[t] = tags[t][0];
        tags[t] = tags[t].trim();
        tags[t] = tags[t].toLowerCase();
      }
      var filtered_tags = tags.filter(f => face_all_tags.includes(f));
      // console.log(filtered_tags)
      $(this).find('.strap-finder__watch-filter-tags').each(function(){
        var target =  $(this).attr('target');
        target = target.trim();
        target = target.toLowerCase();
        var show = false;
        for (let t = 0; t < filtered_tags.length; t++) {
          filtered_tags[t] = filtered_tags[t].trim();
          filtered_tags[t] = filtered_tags[t].toLowerCase();
          if (target == filtered_tags[t]) {
            show = true;
          }
        }
        if (!show) {
          $(this).addClass('no-product');
          $(this).addClass('hide')
        } else {
          $(this).removeClass('no-product');
          show_category = true;
        }
      });
    });
    
    $('.strap-finder__face-container').each(function(){
      var show_category = false;
      var tags = $(this).attr('tags');
      tags = tags.split(',')
      for (let t = 0; t < tags.length; t++) {
        tags[t] = tags[t].split('=');
        tags[t] = tags[t][0];
        tags[t] = tags[t].trim();
        tags[t] = tags[t].toLowerCase();
      }
      var filtered_tags = tags.filter(f => face_all_tags.includes(f));
      $(this).find('.strap-finder__watch-filter-tags').each(function(){
        var target =  $(this).attr('target');
        target = target.trim();
        target = target.toLowerCase();
        var show = false;
        for (let t = 0; t < filtered_tags.length; t++) {
          filtered_tags[t] = filtered_tags[t].trim();
          filtered_tags[t] = filtered_tags[t].toLowerCase();
          if (target == filtered_tags[t]) {
            show = true;
          }
        }
        if (!show) {
          $(this).addClass('no-product');
          $(this).addClass('hide')
        } else {
          $(this).removeClass('no-product');
          show_category = true;
        }
      });
      $(this).find('.strap-finder__face-swatch').each(function(){
        if (!$(this).hasClass('face-swatch-button')){
          var watch_tag = $(this).attr('tag');
          var show = false;
          if (watch_tag != undefined) {
            watch_tag = watch_tag.split(',')
            // console.log($(this));
            // console.log(filtered_tags)
            // console.log(watch_tag)
            for (let t = 0; t < filtered_tags.length; t++) {
              filtered_tags[t] = filtered_tags[t].trim();
              filtered_tags[t] = filtered_tags[t].toLowerCase();
              for (let w = 0; w < watch_tag.length; w++) {
                watch_tag[w] = watch_tag[w].trim();
                watch_tag[w] = watch_tag[w].toLowerCase();
                if (watch_tag[w] == filtered_tags[t]) {
                  show = true;
                }
              }
            }
            if (!show) {
              if ($(this).attr('title') == 'Select a Watch') {

              } else {
                $(this).addClass('otherbrand');
                $('.strap-finder__other-brands').show();
              }
              
            }
          }
        }
      });
    });
    //setting select option same with the lug width
    if ($(window).width() < 769 ) {
      initDraggableMobile();
    }
  });
  

  //zoom
  var zoom = 0.7;
  $('.image-zoom').attr('scale',zoom);
  $('.zoom').on('click', function(){
    var current_zoom = $('.zoom-range').val();
    current_zoom = parseFloat(current_zoom);
    // console.log(current_zoom);
    current_zoom += 0.1;
    $('.zoom-range').val(current_zoom);
    $('.zoom-range').change();
  });
  $('.zoom-init').on('click', function(){
    var current_zoom = 0.7;
    $('.zoom-range').val(current_zoom);
    $('.zoom-range').change();
  });
  $('.zoom-out').on('click', function(){
    var current_zoom = $('.zoom-range').val();
    current_zoom -= 0.1;
    $('.zoom-range').val(current_zoom);
    $('.zoom-range').change();
  });

  $('.zoom-range').on('input',function(){
    var zoom = $(this).val();
    $('.image-zoom').css('transform', 'scale(' + zoom + ')');
  })

  //face select
  var strap_container = $('.strap-finder__strap-swatch-container');
  if ($(window).width() < 769){
    strap_container = $('.strap-finder__strap-swatch-container-mobile');
  }
  if ($(window).width() > 768) {
    var $carousel = $('.carousel');
    $('.strap-finder__face-swatch').click(function(){
      // console.log("CLICK")
      if (!$(this).hasClass('face-swatch-button') && !$(this).hasClass('strap-finder__watch-filter-tags')) {
        // console.log("FILTER")
        var selector = $(this).attr('value');
        var title = $(this).attr('title');
        var desc = $(this).attr('desc');
        var image_src  = $(this).find('img').attr('src');
        var desc_target = $('.strap-finder__face-description.desktop');
        var desc_title = $('.strap-finder__face-title.desktop');
        $(this).addClass('selected');
        $(this).siblings().removeClass('selected');
        changeFaceDesc(desc, title, desc_target, desc_title);
        changeWatchImage(image_src);

        IncludeExcludeFunction(selector, desc, desc_target, desc_title);
        reduceFilter();
        var margin_top = $(this).attr('margin-top');
        var margin_bottom = $(this).attr('margin-bottom');
        if (margin_top != null && margin_top != undefined && margin_top != '') {
          margin_top = margin_top.split('=');
          margin_top = margin_top[1].trim() + '%';
          margin_top = margin_top.toString();
          $('.image-container.watch').attr('margin-top', margin_top)
          $('.image-container.watch').css("margin-top", `${margin_top}`);
        } else {
          $('.image-container.watch').attr('margin-top', '-30')
          $('.image-container.watch').css("margin-top", '');
        }
        if (margin_bottom != null && margin_bottom != undefined && margin_bottom != '') {
          margin_bottom = margin_bottom.split('=');
          margin_bottom = margin_bottom[1].trim() + '%';
          margin_bottom = margin_bottom.toString();
          $('.image-container.watch').attr('margin-bottom', margin_bottom)
          $('.image-container.watch').css("margin-bottom", margin_bottom);
        } else {
          $('.image-container.watch').attr('margin-bottom', '-30')
          $('.image-container.watch').css("margin-bottom", '');
        }
      }
    });
  } else {
    $('.strap-finder__pop-up-overview').on( 'click', '.strap-finder__strap-swatch', function(close) {
      if (close != 'false') {
        $('.strap-finder__pop-up-overview').removeClass('active');
        $('.strap-finder__pop-up-overlay').removeClass('active');
      } 
      var index = $(this).attr('index');
      parseInt(index)
      var selector = $('.strap-finder__face-swatch.index--' + index).attr('value');
      var title = $('.strap-finder__face-swatch.index--' + index).attr('title');
      var desc = $('.strap-finder__face-swatch.index--' + index).attr('desc');
      var image_src  = $('.strap-finder__face-swatch.index--' + index + ' img').attr('src');
      var desc_target = $('.strap-finder__face-description.mobile');
      var desc_title = $('.strap-finder__face-title.mobile');
      // console.log(image_src,'image_src 2',index);
      $('.strap-finder__watch-button img').attr('src', image_src);
      $(this).addClass('selected');
      $(this).siblings().removeClass('selected');
      changeFaceDesc(desc, title, desc_target, desc_title);
      changeWatchImage(image_src);
      IncludeExcludeFunction(selector, desc);
      reduceFilter();
      var margin_top = $(this).attr('margin-top');
      var margin_bottom = $(this).attr('margin-bottom');
      if (margin_top != null && margin_top != undefined && margin_top != '') {
        margin_top = margin_top.split('=');
        margin_top = margin_top[1].trim() + '%';
        margin_top = margin_top.toString();
        $('.image-container.watch').css("margin-top", `${margin_top}`);
      } else {
        $('.image-container.watch').css("margin-top", '');
      }
      if (margin_bottom != null && margin_bottom != undefined && margin_bottom != '') {
        margin_bottom = margin_bottom.split('=');
        margin_bottom = margin_bottom[1].trim() + '%';
        margin_bottom = margin_bottom.toString();
        $('.image-container.watch').css("margin-bottom", margin_bottom);
      } else {
        $('.image-container.watch').css("margin-bottom", '');
      }
    });
  }
  
  function changeFaceDesc(desc, title, desc_target, desc_title) {
    desc_target.empty();
      if (desc.includes(',')) {
        desc = desc.split(',');
        for (let d = 0; d < desc.length ; d++) {
          let container = $('<div class="strap-finder__split-container"></div>');
          let new_desc = $('<p class="strap-finder__alt-content">'+  desc[d]  +'</p>');
          container.append(new_desc);
          desc_target.append(container);
        }
      } else {
        let new_desc = $('<p class="strap-finder__alt-content">'+  desc  +'</p>');
        desc_target.append(new_desc);
      }
      
      desc_title.text(title);
  }

  function changeWatchImage(image_src) {
    $('.strap-finder__main .watch img').attr('src', image_src);
    $('.strap-finder__main .watch .image-element__wrap').empty();
    $('.strap-finder__main .watch .image-element__wrap').append('<img class="transition--fade-in zoom-img lazyload" src=' + image_src + ' />');
  }

  function IncludeExcludeFunction(selector, desc) {
    desc = desc.split(',');
    //include and exclude functionality
    if (selector.includes('include_only')) {
      var selector_tags = selector.split('=');
      selector_tags[1] = selector_tags[1].split(',')
      strap_container.find('.strap-finder__strap-swatch').each(function(){
        var show = false;
        $(this).addClass('hide');
        let tags = $(this).attr('tag')
        if (tags != undefined) {
          tags = tags.split('/');
          for (let c = 0; c < selector_tags[1].length; c++) {
            selector_tags[1][c] = selector_tags[1][c].trim();
            for (let p = 0; p < tags.length; p++) {
              if (selector_tags[1][c] == tags[p]){
                show = true;
              }
            }
          }
        }
      
        if (show) {
          $(this).removeClass('hide');  
          if ($(this).hasClass('selected')) {
            var lugwidth = desc[1].split(':');
            lugwidth = lugwidth[1].replace('mm','').trim();
            $('.strap-finder-selector__container').find('[option="'+ 1 + '"] option').each(function(index){

              var optlug = $(this).attr('value').split('-');
              optlug = optlug[0].trim();
              var option_value = $(this).attr('value');
              if (lugwidth == optlug) {
                $(this).siblings().removeAttr('selected');
                $(this).siblings().prop('selected',false);
                $(this).attr('selected', 'selected');
                $(this).prop('selected', 'selected');
                $(this).eq(index).prop('selected', true);
                // var label = $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').siblings('.strap-finder__watch-title')
                // label.text(label.text() + " : " + optlug)

                $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').val($(this).attr('value'));
                $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').change();
              }
            });
          }
        }
      });
    } else if (selector.includes('exclude')) {
      var selector_tags = selector.split('=');
      selector_tags[1] = selector_tags[1].split(',');
      strap_container.find('.strap-finder__strap-swatch').each(function(){
        var hide = false;
        $(this).removeClass('hide');
        let tags = $(this).attr('tag')
        if (tags != undefined) {
          tags = tags.split('/');
          for (let c = 0; c < selector_tags[1].length; c++) {
            for (let p = 0; p < tags.length; p++) {
              if (selector_tags[1][c] == tags[p]){
                hide = true;
              }
            }
          }
        }
        if (hide) {
          $(this).addClass('hide');
          if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
          }
        } else {
          if ($(this).hasClass('selected')) {
            var lugwidth = desc[1].split(':');
            lugwidth = lugwidth[1].replace('mm','').trim();
            $('.strap-finder-selector__container').find('[option="'+ 1 + '"] option').each(function(){
              var optlug = $(this).attr('value').split('-');
              optlug = optlug[0].trim();
              if (lugwidth == optlug) {
                $(this).siblings().removeAttr('selected');
                $(this).attr('selected', 'selected');
                // console.log("test 2")
                $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').val($(this).attr('value'));
                $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').change();
              }
            });
          }
        }
      });
    } else {
      strap_container.find('.strap-finder__strap-swatch').each(function(){
        $(this).removeClass('hide');
        if ($(this).hasClass('selected')) {
          var lugwidth = desc[1].split(':');
          lugwidth = lugwidth[1].replace('mm','').trim();
          $('.strap-finder-selector__container').find('[option="'+ 1 + '"] option').each(function(){
            var optlug = $(this).attr('value').split('-');
            optlug = optlug[0].trim();
            if (lugwidth == optlug) {
              $(this).siblings().removeAttr('selected');
              $(this).attr('selected', 'selected');
              $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').val($(this).attr('value'));
              $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').change();
            }
          });
        }
      });
    }
    
    var newselected = true;
    strap_container.find('.strap-finder__strap-swatch').each(function(){
      if ($(this).hasClass('selected') && $(this).hasClass('hide')) {
        if (newselected) {
          newselected = false;
          strap_container.find('.strap-finder__strap-swatch').each(function(){
            if (!$(this).hasClass('hide')) {
              $(this)[0].click();

              return false;
            } 
          });
          return false;
        }
      }
    });
    
  }



  function reduceFilter() {
    var alltags = [];
      strap_container.find('.strap-finder__strap-swatch').each(function(){
        if (! $(this).hasClass('hide-strap')) {
          var tags = $(this).attr('filtertags');
          tags = tags.split('%');
          for (let o = 0; o < tags.length; o++) {
            tags[o] = tags[o].trim();
            tags[o] = tags[o].toLowerCase();
            var exist = false;
            for (let t = 0; t < alltags.length; t++) {
              if (alltags[t] == tags[o]) {
                exist = true;
              }
            }
            if (exist == false) {
              alltags.push(tags[o])
            }
          }
        }
      });
      $('.strap-finder__filter.swatch').each(function(){
        var show_category = false;
        var tags = $(this).attr('tags');
        tags = tags.split(',')
        for (let t = 0; t < tags.length; t++) {
          tags[t] = tags[t].trim();
          tags[t] = tags[t].toLowerCase();
        }
        var filtered_tags = tags.filter(f => alltags.includes(f));
        $(this).find('.strap-finder__filter-tags').each(function(){
          var target =  $(this).attr('target');
          target = target.trim();
          target = target.toLowerCase();
          var show = false;
          for (let t = 0; t < filtered_tags.length; t++) {
            filtered_tags[t] = filtered_tags[t].trim();
            filtered_tags[t] = filtered_tags[t].toLowerCase();
            if (target == filtered_tags[t]) {
              show = true;
            }
          }
          if (!show) {
            $(this).addClass('no-product');
          } else {
            $(this).removeClass('no-product');
            show_category = true;
          }
        });
        if (show_category) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
  }

  function reduceFIlterFace() {
    // console.log("reduce face filter")
    var face_all_tags = [];
    $('.strap-finder__face-swatch').each(function(){
      if (!$(this).hasClass('hide-strap') && !$(this).hasClass('face-swatch-button') && !$(this).hasClass('strap-finder__watch-filter-tags')) {
        var show_category = false;
        var tags = $(this).attr('tag');
        tags = tags.split(',')
        for (let p = 0; p < tags.length; p++) {
          var exist = false;
          tags[p] = tags[p].trim();
          tags[p] = tags[p].toLowerCase();
          for (let t = 0; t < face_all_tags.length; t++) {
            if (face_all_tags[t] == tags[p]) {
              exist = true;
            }
          }
          if (!exist) {
            face_all_tags.push(tags[p]);
          }
        }
      }
    });
    // console.log(face_all_tags)
    $('.strap-finder__filter.face').each(function(){
      var show_category = false;
      var tags = $(this).attr('tags');
      tags = tags.split(',')
      for (let t = 0; t < tags.length; t++) {
        tags[t] = tags[t].trim();
        tags[t] = tags[t].toLowerCase();
      }
      var filtered_tags = tags.filter(f => face_all_tags.includes(f));
      $(this).find('.strap-finder__watch-filter-tags').each(function(){
        var target =  $(this).attr('target');
        target = target.trim();
        target = target.toLowerCase();
        var show = false;
        for (let t = 0; t < filtered_tags.length; t++) {
          filtered_tags[t] = filtered_tags[t].trim();
          filtered_tags[t] = filtered_tags[t].toLowerCase();
          if (target == filtered_tags[t]) {
            show = true;
          }
        }
        if (!show) {
          $(this).addClass('no-product');
        } else {
          $(this).removeClass('no-product');
          show_category = true;
        }
      });
      if (show_category) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    
    $('.strap-finder__face-container').each(function(){
      var show_category = false;
      var tags = $(this).attr('tags');
      tags = tags.split(',')
      for (let t = 0; t < tags.length; t++) {
        tags[t] = tags[t].split('=');
        tags[t] = tags[t][0];
        tags[t] = tags[t].trim();
        tags[t] = tags[t].toLowerCase();
      }
      var filtered_tags = tags.filter(f => face_all_tags.includes(f));
      // console.log(filtered_tags)
      $(this).find('.strap-finder__watch-filter-tags').each(function(){
        var target =  $(this).attr('target');
        target = target.trim();
        target = target.toLowerCase();
        var show = false;
        for (let t = 0; t < filtered_tags.length; t++) {
          filtered_tags[t] = filtered_tags[t].trim();
          filtered_tags[t] = filtered_tags[t].toLowerCase();
          if (target == filtered_tags[t]) {
            show = true;
          }
        }
        if (!show) {
          $(this).addClass('no-product');
        } else {
          $(this).removeClass('no-product');
          show_category = true;
        }
      });
    });
  }
  //strap select 
  if ($(window).width() > 768) {
    $(".strap-finder__strap-swatch-container").on('click', '.strap-finder__strap-swatch', (event) => {
      strapselect();
      console.log('here 1')
    });
  } else {
    $(".strap-finder__strap-swatch-container-mobile").on('click', '.strap-finder__strap-swatch', (event) => {
      strapselect();
      var img_src = $(event.target).find('img').attr('src');
      if (img_src == undefined) {
        img_src = $(event.target).attr('src');
      }
      $('.strap-finder__strap-mobile').attr('src', img_src);
    });
  }
  function strapselect() {
    var parent = $(event.target).parent('.strap-finder__strap-swatch');
    console.log(parent,'parenttt');
    if ($(event.target).hasClass('strap-finder__strap-swatch')) {
      parent = $(event.target)
    }
    var data_variant = parent.attr('data-variants');
    parent.addClass('selected');
    parent.siblings().removeClass('selected');
    $('.strap-finder-selector__container').empty();
    $('[data-variant-selector]').empty();
    $('.strap-finder-selector__container').empty();
    $('[data-variant-selector]').empty();

    $('.image-container.top-strap').append('<img class="transition--fade-in zoom-img lazyautosizes lazyload" src=' + top_strap + '/>')
    $('.image-container.bottom-strap').append('<img class="transition--fade-in zoom-img lazyautosizes lazyload" src=' + bottom_strap + '/>')
    var option_names = parent.attr('option');
    option_names = option_names.split(',');
    var data_variant = data_variant.split(',');
    var title = parent.attr('title');
    var var_options
    //main selector
    var optlugchecker = true;
    for (var i = 0; i < data_variant.length; i++ ) {
      var variant = data_variant[i].split('/');
      if (variant.length >= 5) {
        for (var a = 4; a < variant.length; a++ ) {
          variant[3] = variant[3]  + '/' + variant[a];
        }
      }
      var variant_id = parseInt(variant[0])
      var_options = variant[3].split('%');
      var option = $('<option></option>').attr({"value":variant_id},{"availability":variant[1]}).text(variant[0]);
      $('.single-option-selector.size').append('<option value=' + variant_id +' availability=' + variant[2] + '>'+ variant[1] + '</option>');

      var option = $('<option value=' + variant_id +' availability=' + variant[1] + ' price=' + variant[2] + '>'+ variant_id + '</option>');
       
      for (let o = 1; o <= var_options.length; o++) {
        if (o == 1) {
        option.attr('option1', var_options[0])
        }
        if (o == 2) {
        option.attr('option2', var_options[1])
        }
        if (o == 3) {
        option.attr('option3', var_options[2])
        }
      }

      $('[data-variant-selector]').append(option);
      // var watch_desc = $('.carousel-cell.is-selected').attr('desc');
      var watch_desc = $('.strap-finder__face-swatch.selected').attr('desc');
      watch_desc = watch_desc.split(',');
      var lugwidth = watch_desc[1].split(':');
      lugwidth = lugwidth[1].replace('mm','').trim();
      var optlug;
      if ( var_options[0].includes('-')) {
        optlug =  var_options[0].split('-');
        optlug = optlug[0].trim();
      }
      
      if (optlug == lugwidth) {
        if (optlugchecker) {
          $('[data-variant-selector]').val(variant_id);
          $('.strap-finder .button--add-to-cart').attr('data-vid', variant_id);
          optlugchecker = false;
        }
      } else if (i == 1) {
        $('[data-variant-selector]').val(variant_id);
        $('.strap-finder .button--add-to-cart').attr('data-vid', variant_id);
      }
    }
    //options selector
    for (let o = 1; o <= option_names.length; o++) {
      var select = $('<select class="single-option-selector"></select>');
      if (o == 1) {
        var checker_array = [];
        var checker = true;
        for (let v = 0; v < data_variant.length; v++) {
          checker = true;
          var variant_s = data_variant[v].split('/');
          var avail = variant_s[1];
          if (variant_s.length >= 5) {
            for (var a = 4; a < variant_s.length; a++ ) {
              variant_s[3] = variant_s[3] + '/' + variant_s[a];
            }
          }
          var var_options_s = variant_s[3].split('%');
          var option1 = var_options_s[0];
          for (let c = 0; c < checker_array.length; c++) {
            if (checker_array[c] == option1) {
              checker = false;
            }
          }
          console.log(checker, 'deee 1');
          if (checker == true ){
            checker_array.push(option1)
            // var watch_desc = $('.carousel-cell.is-selected').attr('desc');
            var watch_desc = $('.strap-finder__face-swatch.selected').attr('desc');
            watch_desc = watch_desc.split(',');
            var lugwidth = watch_desc[1].split(':');
            lugwidth = lugwidth[1].replace('mm','').trim();
            var optlug = option1.split('-');
            optlug = optlug[0].trim();
            if (optlug == lugwidth) {
              select.append('<option value="' + option1 + '" selected="selected">'+ var_options_s[0] + '</option>');
              if (option1.includes('- Made-to-Order')) {
                $('.line-item-property__field.custom-made').addClass("show");
                $('.line-item-property__field.custom-made').find('input').each(function(){
                  $(this).removeAttr('disabled');
                })
              } else {
                $('.line-item-property__field.custom-made').find('input').each(function(){
                  $(this).attr('disabled',true);
                })
              }
              if (avail == "true") {
                $('.ajax-submit.action_button').removeAttr('disabled');
                $('.ajax-submit.action_button span').text("Add to cart");
              } else {
                $('.ajax-submit.action_button').attr('disabled',true);
                $('.ajax-submit.action_button span').text("Sold Out");
                console.log('sold out 3');
              }
              if ($('#AgreeCondition').prop('checked') != true) {
                $('.ajax-submit.action_button').attr('disabled',true);
                console.log('tnc false');
              }
              
            } else {
              select.append('<option value="' + option1 + '">'+ var_options_s[0] + '</option>');
            }          
          }
        }   
      }

      if (o == 2) {
        var checker_array = [];
        var checker = true;
        for (let v = 0; v < data_variant.length; v++) {
          checker = true;
          var variant_s = data_variant[v].split('/');
          var avail = variant_s[1];
          if (variant_s.length >= 5) {
            for (var a = 4; a < variant_s.length; a++ ) {
              variant_s[3] = variant_s[3].trim() + '/' + variant_s[a].trim();
            }
          }
          var var_options_s = variant_s[3].split('%');
          var option1 = var_options_s[0];
          var option2 = var_options_s[1];
          for (let c = 0; c < checker_array.length; c++) {
            if (checker_array[c] == option2) {
              checker = false;
            }
          }
          if (checker == true ){
            checker_array.push(option2)

            var watch_desc = $('.strap-finder__face-swatch.selected').attr('desc');
            watch_desc = watch_desc.split(',');
            var lugwidth = watch_desc[1].split(':');
            lugwidth = lugwidth[1].replace('mm','').trim();
            var optlug = option1.split('-');
            optlug = optlug[0].trim();
            if (optlug == lugwidth) {
              select.append('<option value="' + option2 + '" selected="selected">'+ var_options_s[1] + '</option>');
              if (option2.includes('- Made-to-Order')) {
                $('.line-item-property__field.custom-made').addClass("show");
                $('.line-item-property__field.custom-made').find('input').each(function(){
                  $(this).removeAttr('disabled');
                })
              } else {
                $('.line-item-property__field.custom-made').find('input').each(function(){
                  $(this).attr('disabled',true);
                })
              }
              if (avail == "true") {
                $('.ajax-submit.action_button').removeAttr('disabled');
                $('.ajax-submit.action_button span').text("Add to cart");
              } else {
                $('.ajax-submit.action_button').attr('disabled',true);
                $('.ajax-submit.action_button span').text("Sold Out");
                console.log('sold out 4');
              }
            } else {
              select.append('<option value="' + option2 + '">'+ var_options_s[1] + '</option>');
            }   
            

          }
        }   
      }

      if (o == 3) {
        var checker_array = [];
        var checker = true;
        for (let v = 0; v < data_variant.length; v++) {
          checker = true;
          var variant_s = data_variant[v].split('/');
          var avail = variant_s[1];
          if (variant_s.length >= 5) {
            for (var a = 4; a < variant_s.length; a++ ) {
              variant_s[3] = variant_s[3] + '/' + variant_s[a];
            }
          }
          var var_options_s = variant_s[3].split('%');
          var option3 = var_options_s[2];
          for (let c = 0; c < checker_array.length; c++) {
            if (checker_array[c] == option3) {
              checker = false;
            }
          }
          if (checker == true ){
            checker_array.push(option3)
            if (v == 0) {
              select.append('<option value="' + option3 + '" selected="selected">'+ var_options_s[2] + '</option>');
              if (option3.includes('- Made-to-Order')) {
                $('.line-item-property__field.custom-made').addClass("show");
                $('.line-item-property__field.custom-made').find('input').each(function(){
                  $(this).removeAttr('disabled');
                })
              } else {
                $('.line-item-property__field.custom-made').find('input').each(function(){
                  $(this).attr('disabled',true);
                })
              }
              if (avail == "true") {
                $('.ajax-submit.action_button').removeAttr('disabled');
                $('.ajax-submit.action_button span').text("Add to cart");
              } else {
                $('.ajax-submit.action_button').attr('disabled', true);
                $('.ajax-submit.action_button span').text("Sold Out");
                console.log('sold out 5');
              }     
            } else {
              select.append('<option value="' + option3 + '">'+ var_options_s[2] + '</option>');
            }
          }
        }   
      }

      p = o - 1;
      var label = $('<label>' + option_names[p] + '</label>');
      select.attr('option',o);
      var select_container = $('<div class="strap-finder__select-container"></div>')
      select_container.append(label);
      select_container.append(select);
      $('.strap-finder-selector__container').append(select_container);
    }

    $('#i-understand-that-this-is-a-custom-order-and-it-will-take-3-4-weeks-before-the-strap-is-sent-out').prop('checked',false)
    let handle = parent.attr('handle');
    let url = '/products/' + handle;
    $('.strap-finder__strap-title').text(title);
    $('.strap-finder__strap-title').attr('href',url)
    $('.strap-finder__strap-title sdsds').attr('handle',handle)
    console.log(variant[2]);
    $('.current_price').html(formatMoney(variant[2], format));
    $('.image-container.top-strap').empty();
    $('.image-container.bottom-strap').empty();
    var top_strap = parent.attr('top');
    var bottom_strap = parent.attr('bottom');
    $('.image-container.top-strap').append('<img class="transition--fade-in zoom-img lazyautosizes lazyload" src=' + top_strap + '/>')
    $('.image-container.bottom-strap').append('<img class="transition--fade-in zoom-img lazyautosizes lazyload" src=' + bottom_strap + '/>')

    var curr_val = $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').val();
    $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').val(curr_val);
    $('.strap-finder-selector__container').find('[option="'+ 1 + '"]').change();
  }

  $('#i-understand-that-this-is-a-custom-order-and-it-will-take-3-4-weeks-before-the-strap-is-sent-out').change(function(){
    if ($(this).prop('checked') == false) {
      $('.ajax-submit.action_button').attr('disabled', true);
    } else {
      $('.ajax-submit.action_button').removeAttr('disabled');
    }
  });
  
  //main select
  $(".strap-finder-selector__container").on('change', '.single-option-selector', (event) => {
    console.log('variant selector change...');
    var option1;
    var option2;
    var option3;
    $('.single-option-selector').each(function(){
      if ($(this).attr('option') == 1) {
        option1 = $(this).val().trim();
      } else if ($(this).attr('option') == 2) {
        option2 = $(this).val().trim();
      } else if ($(this).attr('option') == 3) {
        option3 = $(this).val().trim();
      }
    });
    
    var no_options = $('.single-option-selector').length;

    var availability = false;
    var price = 0;
    var id = 0;
    var made_to_order = false;
    $('[data-variant-selector] option').each(function(){
      if (no_options == 1) {
        if ($(this).attr('option1') == option1){
          availability  = $(this).attr('availability');
          if (availability) {
            id = $(this).attr("value");
            id = parseInt(id)
            if ($(this).attr('option2').includes('- Made-to-Order') || $(this).attr('option1').includes('- Made-to-Order')){
              made_to_order = true;
            }
          }
          price = $(this).attr('price');
        }
      } else if (no_options == 2) {
        // console.log($(this).attr('option1') + " : " + option1 + " | " + $(this).attr('option2') + " : " + option2)
        if ($(this).attr('option1').trim() == option1 && $(this).attr('option2').trim() == option2){
          console.log('found')
          availability  = $(this).attr('availability');
          if (availability) {
            id = $(this).attr("value");
            id = parseInt(id)
            if ($(this).attr('option2').includes('- Made-to-Order') || $(this).attr('option1').includes('- Made-to-Order')){
              made_to_order = true;
            }
          }
          price = $(this).attr('price');
        }
      } else if (no_options == 3) {
        if ($(this).attr('option1') == option1 && $(this).attr('option2') == option2 && $(this).attr('option3') == option3){
          availability  = $(this).attr('availability');
          if (availability) {
            id = $(this).attr("value");
            id = parseInt(id)
            if ($(this).attr('option2').includes('- Made-to-Order') || $(this).attr('option1').includes('- Made-to-Order')){
              made_to_order = true;
            }
          }
          price = $(this).attr('price');
        }
      }
      if (price == 0) {
        price = $(this).attr('price');
      }
    });
    
    $('[data-variant-selector]').attr('value',id);
    $('[data-variant-selector]').val(id);
    $('.strap-finder .button--add-to-cart').attr('data-vid', id);
    $('.current_price').html(formatMoney(price, format));
    $('[data-variant-selector]').trigger('selectedVariantChanged');
    if (id == 0) {
      $('.ajax-submit.action_button').attr('disabled', true);
      $('.ajax-submit.action_button span').text("Sold Out");
      $('.shopify-payment-button__button').hide();
    } else if (made_to_order){
      $('.line-item-property__field.custom-made').addClass("show");
      $('#i-understand-that-this-is-a-custom-order-and-it-will-take-3-4-weeks-before-the-strap-is-sent-out').prop('checked',false)
      $('.line-item-property__field.custom-made').find('input').each(function(){
        $(this).removeAttr('disabled');
      })
      $('.ajax-submit.action_button').attr('disabled', true);
      $('.shopify-payment-button__button').hide();
      $('.ajax-submit.action_button span').text("Add to cart");
    } else { 
      $('.line-item-property__field.custom-made').find('input').each(function(){
        $(this).attr('disabled',true);
      })
      $('.line-item-property__field.custom-made').removeClass("show");
      $('#i-understand-that-this-is-a-custom-order-and-it-will-take-3-4-weeks-before-the-strap-is-sent-out').prop('checked',false)
      if (availability == "true") {
        $('.ajax-submit.action_button').removeAttr('disabled');
        $('.ajax-submit.action_button span').text("Add to cart");
        $('.shopify-payment-button__button').show();
      } else {
        $('.ajax-submit.action_button').attr('disabled',true);
        $('.ajax-submit.action_button span').text("Sold Out");
        $('.shopify-payment-button__button').hide();
      }
      if ($('#AgreeCondition').prop('checked') != true) {
        $('.ajax-submit.action_button').attr('disabled',true);
      }
    }
  });

  //size guide 
  // $('.strap-finder__size-guide').click(function(){
  //   $('.size-guide__modal').addClass('show');
  //   $('.overlay').addClass('show');
  // });

  // $('.strap-finder__size-guide-close').click(function(){
  //   $('.size-guide__modal').removeClass('show');
  //   $('.overlay').removeClass('show');
  // });

  $('.overlay').click(function(){
    $('.size-guide__modal').removeClass('show');
    $('.overlay').removeClass('show');
  });

  //draggable
  //Make the DIV element draggagle:
  function initDraggable() {
    var dragItem = document.querySelector("#strap-image");
    var container = document.querySelector("#strap-container");

    var active = false;
    var currentX;
    var currentY;
    var initialX;
    var initialY;
    var xOffset = dragItem.offsetLeft;
    var yOffset = dragItem.offsetTop;

    container.addEventListener("touchstart", dragStart, false);
    container.addEventListener("touchend", dragEnd, false);
    container.addEventListener("touchmove", drag, false);

    container.addEventListener("mousedown", dragStart, false);
    container.addEventListener("mouseup", dragEnd, false);
    container.addEventListener("mousemove", drag, false);

    function dragStart(e) {
      if (e.type === "touchstart") {
        initialX = e.touches[0].clientX - xOffset;
        initialY = e.touches[0].clientY - yOffset;
      } else {
        initialX = e.clientX - xOffset;
        initialY = e.clientY - yOffset;
      }
      
      if (e.target === dragItem) {
        active = true;
      }

    }

    function dragEnd(e) {
      initialX = currentX;
      initialY = currentY;
      active = false;
    }

    function drag(e) {
      if (active) {
        e.preventDefault();
      
        if (e.type === "touchmove") {
          currentX = e.touches[0].clientX - initialX;
          currentY = e.touches[0].clientY - initialY;
        } else {
          currentX = e.clientX - initialX;
          currentY = e.clientY - initialY;
        }
        xOffset = currentX;
        yOffset = currentY;

        setTranslate(currentX, currentY, dragItem);
      }
    }

    function setTranslate(xPos, yPos, el) {
      if ($(window).width() > 481) {
        el.style.left =  "calc( 50% + " + xPos + "px)";
        el.style.top =  "calc(" + yPos + "px)";
      } else {
        el.style.left =  "calc( 50% + " + xPos + "px)";
        el.style.top =  "calc( 50% + " + yPos + "px)";
      }
    }
  }
  function initDraggableMobile() {
      var MIN_SCALE = 0.55; // 1=scaling when first loaded
      var MAX_SCALE = 3;
      var imgWidth = null;
      var imgHeight = null;
      var viewportWidth = null;
      var viewportHeight = null;
      var scale = null;
      var lastScale = null;
      var container = null;
      var img = null;
      var x = 0;
      var lastX = 0;
      var y = 0;
      var lastY = 0;
      var pinchCenter = null;

      // We need to disable the following event handlers so that the browser doesn't try to
      // automatically handle our image drag gestures.
      var disableImgEventHandlers = function () {
        var events = ['onclick', 'onmousedown', 'onmousemove', 'onmouseout', 'onmouseover',
                      'onmouseup', 'ondblclick', 'onfocus', 'onblur'];

        events.forEach(function (event) {
          img[event] = function () {
            return false;
          };
        });
      };

      // Traverse the DOM to calculate the absolute position of an element
      var absolutePosition = function (el) {
        var x = 0,
          y = 0;

        while (el !== null) {
          x += el.offsetLeft;
          y += el.offsetTop;
          el = el.offsetParent;
        }

        return { x: x, y: y };
      };

      var restrictScale = function (scale) {
        if (scale < MIN_SCALE) {
          scale = MIN_SCALE;
        } else if (scale > MAX_SCALE) {
          scale = MAX_SCALE;
        }
        return scale;
      };

      var restrictRawPos = function (pos, viewportDim, imgDim) {

        return pos;
      };

      var updateLastPos = function (deltaX, deltaY) {
        lastX = x;
        lastY = y;
      };

      var translate = function (deltaX, deltaY) {
        // We restrict to the min of the viewport width/height or current width/height as the
        // current width/height may be smaller than the viewport width/height

        var newX = restrictRawPos(lastX + deltaX/scale,
                                  Math.min(viewportWidth, curWidth), imgWidth);
        x = newX;
        img.style.left =  "calc( 50% + " +  Math.ceil(newX*scale) + "px)";

        var newY = restrictRawPos(lastY + deltaY/scale,
                                  Math.min(viewportHeight, curHeight), imgHeight);
        y = newY;
        img.style.top =  "calc( 50% + " + Math.ceil(newY*scale) + "px)";
      };

      var zoom = function (scaleBy) {
        scale = restrictScale(lastScale*scaleBy);

        curWidth = imgWidth*scale;
        curHeight = imgHeight*scale;
        
        var current_scale = $('.image-zoom').attr('scale');
        current_scale = parseFloat(current_scale)
          $('.image-zoom').css('transform', 'scale(' + scale + ')');
          $('.image-zoom').attr('scale',scale)

        
       
       
        // img.style.width = Math.ceil(curWidth) + 'px';
        // img.style.height = Math.ceil(curHeight) + 'px';

        // Adjust margins to make sure that we aren't out of bounds
        translate(0, 0);
      };

      var rawCenter = function (e) {
        var pos = absolutePosition(container);

        // We need to account for the scroll position
        var scrollLeft = window.pageXOffset ? window.pageXOffset : document.body.scrollLeft;
        var scrollTop = window.pageYOffset ? window.pageYOffset : document.body.scrollTop;

        var zoomX = -x + (e.center.x - pos.x + scrollLeft)/scale;
        var zoomY = -y + (e.center.y - pos.y + scrollTop)/scale;

        return { x: zoomX, y: zoomY };
      };

      var updateLastScale = function () {
        lastScale = scale;
      };

      var zoomAround = function (scaleBy, rawZoomX, rawZoomY, doNotUpdateLast) {
        // Zoom
        zoom(scaleBy);

        // New raw center of viewport
        var rawCenterX = -x + Math.min(viewportWidth, curWidth)/2/scale;
        var rawCenterY = -y + Math.min(viewportHeight, curHeight)/2/scale;

        // Delta
        var deltaX = (rawCenterX - rawZoomX)*scale;
        var deltaY = (rawCenterY - rawZoomY)*scale;

        // Translate back to zoom center
        translate(deltaX, deltaY);

        if (!doNotUpdateLast) {
          updateLastScale();
          updateLastPos();
        }
      };

      var zoomCenter = function (scaleBy) {
        // Center of viewport
        var zoomX = -x + Math.min(viewportWidth, curWidth)/2/scale;
        var zoomY = -y + Math.min(viewportHeight, curHeight)/2/scale;

        zoomAround(scaleBy, zoomX, zoomY);
      };

      var zoomIn = function () {
        zoomCenter(2);
      };

      var zoomOut = function () {
        zoomCenter(1/2);
      };

      function onLoad() {

        img = document.getElementById('mobile-image');
        container = document.getElementById('strap-image');
        imgWidth = img.offsetWidth;
        imgHeight = img.offsetWidth;
        viewportWidth = img.offsetWidth;
        scale = viewportWidth/imgWidth;
        lastScale = scale;
        viewportHeight = img.parentElement.offsetHeight;
        curWidth = imgWidth*scale;
        curHeight = imgHeight*scale;
        var hammer = new Hammer(container, {
          domEvents: true
        });

        hammer.get('pinch').set({
          enable: true
        });

        hammer.on('pan', function (e) {
          translate(e.deltaX, e.deltaY);
        });

        hammer.on('panend', function (e) {
          updateLastPos();
        });

        hammer.on('pinch', function (e) {

          // We only calculate the pinch center on the first pinch event as we want the center to
          // stay consistent during the entire pinch
          if (pinchCenter === null) {
            pinchCenter = rawCenter(e);
            var offsetX = pinchCenter.x*scale - (-x*scale + Math.min(viewportWidth, curWidth)/2);
            var offsetY = pinchCenter.y*scale - (-y*scale + Math.min(viewportHeight, curHeight)/2);
            pinchCenterOffset = { x: offsetX, y: offsetY };
          }

          var newScale = restrictScale(scale*e.scale);
          var zoomX = pinchCenter.x*newScale - pinchCenterOffset.x;
          var zoomY = pinchCenter.y*newScale - pinchCenterOffset.y;
          var zoomCenter = { x: zoomX/newScale, y: zoomY/newScale };

          zoomAround(e.scale, zoomCenter.x, zoomCenter.y, true);
        });

        hammer.on('pinchend', function (e) {
          updateLastScale();
          updateLastPos();
          pinchCenter = null;
        });

        hammer.on('doubletap', function (e) {
          var c = rawCenter(e);
          zoomAround(2, c.x, c.y);
        });

      };
      if(document.readyState !== 'loading') {
        onLoad();
      } else {
       document.addEventListener('DOMContentLoaded', function () {
         setTimeout(function(){
          onLoad();
         },3000);
        
       })
      }
      
  }
  if ($(window).width() > 768) {
    initDraggable();
  } 

  //popup overview
  $('.strap-finder__watch-button').click(function(){
    $('.strap-finder__pop-up-overview').addClass('active');
    $('.strap-finder__pop-up-overlay').addClass('active');
    $('body').addClass("modal-open");
  });
  $('.strap-finder__watch-button-strap').click(function(){
    $('.strap-finder__pop-up-overview-strap').addClass('active');
    $('.strap-finder__pop-up-overlay').addClass('active');
    $('body').addClass("modal-open");
  });

  $('.strap-finder__pop-up-overview-strap').on('click', '.strap-finder__strap-swatch',  function() {
    $('.strap-finder__pop-up-overview-strap').removeClass('active');
    $('.strap-finder__pop-up-overlay').removeClass('active');
  })
  $('.strap-finder__watch-button-cart').click(function(){
    $('.strap-finder__selectWadd-container').addClass('active');
    $('.strap-finder__pop-up-overlay-cart').addClass('active');
    $('body').addClass("modal-open");
  });
  $('.strap-finder__pop-up-overlay, .strap-finder__overview-close, .strap-finder__pop-up-overlay-cart').click(function(){
    $('.strap-finder__pop-up-overview').removeClass('active');
    $('.strap-finder__pop-up-overview-strap').removeClass('active');
    $('.strap-finder__selectWadd-container').removeClass('active');
    $('.strap-finder__pop-up-overlay-cart').removeClass('active');
    $('.strap-finder__pop-up-overlay').removeClass('active');
    $('.size-guide__modal').removeClass('show');
    $('.overlay').removeClass('show');
    $('body').removeClass("modal-open");
    $('.strap-finder__canvas').removeClass('active');
  });

  $('.strap-finder__pop-up-overview').on( 'click', '.strap-finder__strap-swatch', function() {
    if ($(window).width() > 760) {
      var index = $(this).attr('index');
      index = parseInt(index)
      $(this).addClass('selected');
      $(this).siblings().removeClass('selected');
    }
  });

  //filter
  var strap_container = $('.strap-finder__strap-swatch-container');
  if ($(window).width() < 769){
    strap_container = $('.strap-finder__strap-swatch-container-mobile');
  }
  $('.strap-finder__filter-button').click(function(){
    $(this).children('.icon-plus').toggleClass('icon--active');
    $(this).children('.icon-minus').toggleClass('icon--active');
    $(this).siblings('.strap-finder__filter-content').toggleClass('active');
  });

  $('.strap-finder__filter-tags').click(function(){
    $(this).parents('.strap-finder__filter-content').removeClass('active');
    if ($(this).hasClass('tag-active')) {
      $(this).removeClass('tag-active');
      $(this).siblings().removeClass('hide');
      $(this).children('.icon-selected').removeClass('icon--active');
      reduce = true;
    } else {
      $(this).addClass('tag-active');
      $(this).siblings('.strap-finder__filter-tags').addClass('hide');
      $(this).children('.icon-selected').addClass('icon--active');
    }
    // console.log("finding active tags")
    var find_new_watch = false;
    var active_tags = [];
      if ($(this).hasClass('strap-finder__face-swatch')) {
        active_tags.push($(this).attr('target'));
        // console.log("TEST")
      } else {
        $('.strap-finder__filter-tags.tag-active').each(function(){
          let filter_tag = $(this).attr('target');
          filter_tag = filter_tag.trim();
          filter_tag = filter_tag.toLowerCase();
          active_tags.push(filter_tag);
        });
      }
      if(active_tags.length > 0) {
        strap_container.find('.strap-finder__strap-swatch').each(function(){
          var show = false;
          $(this).addClass('hide-strap');
          let tags = $(this).attr('filtertags')
          let checker_no = [];
          if (tags != undefined) {
            tags = tags.split('%');       
            for (let c = 0; c < active_tags.length; c++) {
              for (let p = 0; p < tags.length; p++) {
                tags[p] = tags[p].trim();
                tags[p] = tags[p].toLowerCase();
                if (tags[p] == active_tags[c]){
                  checker_no.push(tags[p]);
                }
              }
            }
          }
         
          if (checker_no.length == active_tags.length) {
            $(this).removeClass('hide-strap');
          } else {
            if ($(this).hasClass('selected')) {
              find_new_watch = true;
            }
          }
        });
      } else {
        strap_container.find('.strap-finder__strap-swatch').each(function(){
          $(this).removeClass('hide-strap');
        });
      }

      if (find_new_watch) {
        strap_container.find('.strap-finder__strap-swatch').each(function(){
          if (!$(this).hasClass('hide-strap')) {
            $(this)[0].click();
            if ($(window).width() < 768) {
              $('.strap-finder__pop-up-overview-strap').addClass('active');
              $('.strap-finder__pop-up-overlay').addClass('active');
            }
            return false;
          }
        })
      }
      reduceFilter();
  });

  
  var $selector_carousel = $('.carousel');
  var cell_array = [];
  var cell_tags = [];
  var cell_desc = [];
  var cell_title = [];
  
  // $('.carousel.related-products').find('.carousel-cell.face').each(function(){
    $('.strap-finder__face-swatch').each(function(){
      if (!$(this).hasClass('face-swatch-button') && !$(this).hasClass('strap-finder__watch-filter-tags')) {
        cell_array.push($(this)[0].outerHTML);
        let tags = $(this).attr('tag');
        tags = tags.trim();
        cell_tags.push(tags);
        let desc = $(this).attr('desc');
        cell_desc.push(desc)
        let title = $(this).attr('title');
        cell_title.push(title);
      }
  });
  
  $('.strap-finder__watch-filter-tags').click(function(){
    // console.log('click')
    $(this).parents('.strap-finder__filter-content').removeClass('active');
    if ($(this).hasClass('tag-active')) {
      $(this).removeClass('tag-active');
      $(this).siblings('.strap-finder__filter-tags').removeClass('hide');
      $(this).children('.icon-selected').removeClass('icon--active');
    } else {
      $(this).addClass('tag-active');
      if (!$(this).hasClass('strap-finder__brand-swatch')) {
        $(this).siblings('.strap-finder__filter-tags').addClass('hide');
      } else {
        $(this).siblings('.strap-finder__watch-filter-tags').addClass('hide-strap');
      }
      $(this).children('.icon-selected').addClass('icon--active');
    }
    var active_tags = [];
      if ($(this).hasClass('strap-finder__brand-swatch')) {
        active_tags.push($(this).attr('target'));
        // console.log("TEST")
        $('.strap-finder__brand-swatch.strap-finder__watch-filter-tags.tag-active').each(function(){
          let filter_tag = $(this).attr('target');
          filter_tag = filter_tag.trim();
          active_tags.push(filter_tag);
          $(this).addClass('hide-strap');
          $('.face-swatch-button').addClass('show_brands');
          $('.face-swatch-button p').text('Show All Brands');
        });
      } else {
        $('.strap-finder__watch-filter-tags.tag-active').each(function(){
          let filter_tag = $(this).attr('target');
          filter_tag = filter_tag.trim();
          filter_tag = filter_tag.toLowerCase();
          active_tags.push(filter_tag);
        });
      }
    // console.log(active_tags)
  
    $('.strap-finder__pop-up-overview').find('.strap-finder__strap-swatch').addClass('hide-strap')
    $('.strap-finder__face-swatch').each(function(){
      if (!$(this).hasClass('face-swatch-button')) {
        $(this).addClass('hide-strap');
      }
    })

    if ($(window).width() > 768) {
      var watch_swatch = $('.strap-finder__face-swatch');
    } else {
      var watch_swatch = $('.strap-finder__pop-up-overview').find('.strap-finder__strap-swatch')
    }

    var find_new_watch = false;
    watch_swatch.each(function(){
      if (!$(this).hasClass('face-swatch-button') && !$(this).hasClass('strap-finder__watch-filter-tags')) {
        $(this).addClass('hide-strap');
        var checker_no = [];
        if(active_tags.length > 0) {
          var face_swatch_tag = $(this).attr('tag');
          var tags_array = face_swatch_tag.split(',');
          for (let o = 0; o < tags_array.length; o++) {
            tags_array[o] = tags_array[o].trim();
            tags_array[o] = tags_array[o].toLowerCase();
            for (let c = 0; c < active_tags.length; c++) {
              if (tags_array[o] == active_tags[c]){
                checker_no.push(tags_array[o]);
              }
            }
          }
          if (checker_no.length == active_tags.length) {
            $(this).removeClass("hide-strap");
          } else {
            if ($(this).hasClass('selected')) {
              // console.log("new watch")
              find_new_watch = true;
            }
          }
        } else {
          watch_swatch.each(function(){
            $(this).removeClass('hide-strap');
          })
        }
      }
    });
    if (find_new_watch) {
      watch_swatch.each(function(){
        if (!$(this).hasClass('face-swatch-button') && !$(this).hasClass('strap-finder__watch-filter-tags')) {
          if (!$(this).hasClass('hide-strap')) {
            $(this)[0].click();
            if ($(window).width() < 768) {
              $('.strap-finder__pop-up-overview').addClass('active');
              $('.strap-finder__pop-up-overlay').addClass('active');
            }
            return false;
          }
        }
      })
    }
    reduceFIlterFace();
  });
  if ($('.otherbrand').length > 0) {
    $('.strap-finder__other-brands').removeClass('hide')
  } else {
    $('.strap-finder__other-brands').addClass('hide');
  }
  $('.face-swatch-button').click(function(){
    if ($(this).hasClass('show_brands')) {
      $(this).removeClass('show_brands');
      $(this).siblings('.strap-finder__face-swatch').addClass('hide-strap');
      $(this).siblings('.strap-finder__strap-swatch').addClass('hide-strap');
      $(this).find('p').text('See All Watches');
      $(this).siblings('.strap-finder__brand-swatch').removeClass('hide-strap');
      $(this).siblings('.strap-finder__brand-swatch').removeClass('no-product');
      $(this).siblings('.strap-finder__brand-swatch').removeClass('tag-active');
      if ($('.otherbrand').length > 0) {
        $('.strap-finder__other-brands').removeClass('hide')
      }
    } else {
      $('.strap-finder__other-brands').addClass('hide')
      $(this).addClass('show_brands');
      $(this).siblings('.strap-finder__strap-swatch').removeClass('hide-strap');
      $(this).siblings('.strap-finder__face-swatch').removeClass('hide-strap');
      $(this).siblings('.strap-finder__brand-swatch').addClass('hide-strap');
      $(this).find('p').text('See All Brands');
      $(this).siblings('.strap-finder__brand-swatch').removeClass('tag-active');
    }
  })
  $('.strap-finder__other-brands').click(function(){
    $('.face-swatch-button').addClass('show_brands');
    $(this).addClass('hide');
    $(this).siblings('.strap-finder__face-swatch').addClass('hide-strap');
    $(this).siblings('.strap-finder__strap-swatch').addClass('hide-strap');
    $(this).siblings('.strap-finder__brand-swatch').addClass('hide-strap');
    $(this).siblings('.otherbrand').removeClass('hide-strap');
  })
  
  //select next or previous item using up down left right
  function initarrowkeys () {
    $(document).on('keydown',function(e) {
      var code = (e.keyCode ? e.keyCode : e.which);
      switch (code){
        case 40:
          var next = $('.strap-finder__face-swatch.selected').next();
          while (next.hasClass('hide') || next.hasClass('hide-strap')) {
            next = next.next();
          }
          if (next.length > 0 && next != undefined) {
            next[0].click();
          }
          e.preventDefault();
          break;
        case 38:
          var prev = $('.strap-finder__face-swatch.selected').prev();
          while (prev.hasClass('hide') || prev.hasClass('hide-strap')) {
            prev = prev.prev();
          }
          if (prev.length > 0 && prev != undefined) {
            prev[0].click();
          }
          e.preventDefault();
          break;
        case 37:
          var prev = $('.strap-finder__selector').find('.strap-finder__strap-swatch.selected').prev();
          while (prev.hasClass('hide') || prev.hasClass('hide-strap')) {
            prev = prev.prev();
           }
          if (prev.length > 0 && prev != undefined) {
            prev[0].click();
          }
          break;
        case 39:
          var next = $('.strap-finder__selector').find('.strap-finder__strap-swatch.selected').next();
          while (next.hasClass('hide') || next.hasClass('hide-strap')) {
            next = next.next();
          }
          if (next.length > 0 && next != undefined) {
            next[0].click();
          }
          break;
      }
    });
  }
  if ($(window).width() > 768) {
   initarrowkeys();
  } 

  $(document).on('input', '.strap-finder__custom-checkbox', function() {
    // console.log($(this).val());
    // console.log($(this).prop('checked'));
    if ($(this).prop('checked') == true) {
      $('[data-add-to-cart-trigger]').removeAttr('disabled');
    } else {
      $('[data-add-to-cart-trigger]').attr('disabled', true);
    }
  })
  
  //Merge then Download
  
  $('.strap-finder__download').click(function(){
    var canvas = document.getElementById('canvas');
    canvas.width = 920;
    canvas.height = 2350;
    var ctx = canvas.getContext('2d');
    mirror = document.getElementById('canvasimg');
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    var imglogo = new Image();
    var img1 = new Image();
    var img3 = new Image();
    var img2 = new Image();
    var imglogo_src = 'https:' + canvas.getAttribute('logo');
    var img1_src =  $('.image-container.top-strap').find('img').attr('src');
    var img1_height = parseFloat($('.image-container.top-strap img').height());
    var img1_width = parseFloat($('.image-container.top-strap img').width());
    var img1_ratio = img1_height / img1_width;
    var img1_newheight = img1_ratio * 600;
    var img2_height = parseFloat($('.image-container.watch img').height());
    var img2_width = parseFloat($('.image-container.watch img').width());
    var img2_ratio = img2_height / img2_width;
    var img2_newheight = img2_ratio * 600;

    var top_strap_margin = 0.765;
    var bottom_strap_margin = 0.72;
    var top_margin_adjust = parseFloat($('.image-container.watch').attr('margin-top').replace('%',''));
    var bottom_margin_adjust = parseFloat($('.image-container.watch').attr('margin-bottom').replace('%',''));
    top_margin_adjust = (30 - (top_margin_adjust * -1)) * 0.01;
    bottom_margin_adjust = (30 - (bottom_margin_adjust * -1)) * 0.01;
    top_strap_margin = top_strap_margin + top_margin_adjust;
    bottom_strap_margin = bottom_strap_margin +  bottom_margin_adjust;
    // console.log(top_margin_adjust + ":" + bottom_margin_adjust);
    // console.log(top_strap_margin + ":" + bottom_strap_margin);
    var img2_start_pos = (img1_newheight * top_strap_margin) + 320;
    var img3_start_pos = img2_start_pos + (img2_newheight* bottom_strap_margin);

    if (img1_src.includes('?')) {
      img1_src = img1_src.split('?');
      img1_src = img1_src[0];
    }
    var img3_src = $('.image-container.bottom-strap').find('img').attr('src');
    if (img3_src.includes('?')) {
      img3_src = img3_src.split('?');
      img3_src = img3_src[0];
    }
    var img2_src = $('.image-container.watch').find('img').attr('src');
    if (img2_src.includes('?')) {
      img2_src = img2_src.split('?');
      img2_src = img2_src[0];
    }
    
    imglogo.crossOrigin="anonymous";
    img1.crossOrigin="anonymous";
    img3.crossOrigin="anonymous";
    img2.crossOrigin="anonymous";
    
    imglogo.setAttribute('crossOrigin', 'anonymous');
    img1.setAttribute('crossOrigin', 'anonymous');
    img3.setAttribute('crossOrigin', 'anonymous');
    img2.setAttribute('crossOrigin', 'anonymous');

    imglogo.onload = function() {
      ctx.drawImage(imglogo, 283.185, 20, 353.63,110 );
    } 
    var count = 0;
    img1.onload = function() {
      count = count + 1;
      ctx.drawImage(img1, 160, 320, 600, img1_newheight);
    }
  
    
    img3.onload = function() {
      ctx.drawImage(img3, 160, img3_start_pos, 600, 1009.95025);
      img2.src = img2_src;
      count = count + 1;
    }

    
    img2.onload = function() {
      var checkCount = setInterval(function(){ 
        if (count == 2) {
          clearInterval(checkCount);
          ctx.drawImage(img2, 160, img2_start_pos, 600, img2_newheight);
          done = true;
        }
      }, 50);
  }

    var strap_text = document.querySelector('.strap-finder__strap-title');
    var strap = 'Strap: ' + strap_text.textContent;
    var watch_text
    if ($(window).width() > 768) {
      watch_text = document.querySelector('.strap-finder__face-title.desktop');
    } else {
      watch_text = document.querySelector('.strap-finder__face-title.mobile');
    }
    var watch = 'Watch: ' + watch_text.textContent;
    ctx.fillStyle = "black";
    ctx.font = "bold 32px Mundo Sans";
    ctx.fillText(watch, 40, 260);
    ctx.fillText(strap, 40, 296);

    var bottom_text = canvas.getAttribute('bottom');
    ctx.font = "bold 32px Mundo Sans";
    ctx.fillText(bottom_text, 170, 2330);

    var top_text = canvas.getAttribute('top');
    ctx.font = "bold 40px Mundo Sans";
    ctx.fillText(top_text, 360, 190);

    var done = false;

    imglogo.src = imglogo_src;
    img1.src = img1_src;
    img3.src = img3_src;

    var checkDone = setInterval(function(){ 
      if (done) {
        clearInterval(checkDone);
        var dataURL = canvas.toDataURL()
        mirror.src = dataURL;
        var title = $('.strap-finder__strap-title').attr('handle');
        title = 'Delugs Strap Finder - ' + title ;
        $('.strap-finder__download-button').attr('href', dataURL);
        $('.strap-finder__download-button').attr('download', title);
        if ($(window).width() > 768) {
          $('.strap-finder__download-button')[0].click()
          // $('.strap-finder__canvas').addClass('active');
          // $('.strap-finder__pop-up-overlay').addClass('active');
        } else {
          $('.strap-finder__canvas').addClass('active');
          $('.strap-finder__pop-up-overlay').addClass('active');
        }
      }
    },50);
  });
}